import { Button, Typography } from '@mui/material';
import ModalV2 from '/@/components/bayer/modal-v2';
import { _ } from '/@/locale';

const ExitWithoutSavingModal = ({
    open,
    setClose,
    onDiscard,
}: {
    open: boolean;
    setClose: () => void;
    onDiscard: () => void;
}) => {
    return (
        <ModalV2
            open={open}
            onClose={setClose}
            title={_('¿Querés salir sin guardar?')}
            bodyProps={{ spacing: 3, alignItems: 'flex-start' }}
            actions={
                <>
                    <Button variant='text' color='secondary' onClick={onDiscard}>
                        {_('Descartar y salir')}
                    </Button>
                    <Button variant='contained' color='secondary' onClick={setClose}>
                        {_('Volver')}
                    </Button>
                </>
            }
            actionsProps={{ sx: { justifyContent: 'flex-end' } }}
        >
            <Typography variant='body1' color='primary'>
                {_('Vas a perder los cambios de la carga de cultivo que hiciste hasta ahora.')}
            </Typography>
        </ModalV2>
    );
};

export default ExitWithoutSavingModal;
